
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export interface ConflictDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReloadNewest: () => void;
  onForceOverwrite: () => void;
  onSaveAsCopy: () => void;
  conflictType: 'minor' | 'major';
}

export const ConflictDialog: React.FC<ConflictDialogProps> = ({
  open,
  onOpenChange,
  onReloadNewest,
  onForceOverwrite,
  onSaveAsCopy,
  conflictType,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Version Conflict Detected</DialogTitle>
          <DialogDescription>
            {conflictType === 'major' ? 
              "This drawing has been significantly modified elsewhere. What would you like to do?" :
              "This drawing has been modified elsewhere. How would you like to proceed?"}
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          <p className="text-sm text-gray-600">
            {conflictType === 'major' ?
              "There are multiple versions ahead of your current version. Your changes might conflict with those modifications." :
              "There is a newer version of this drawing available."}
          </p>
        </div>
        
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onReloadNewest}>
            Load Latest Version
          </Button>
          {conflictType !== 'major' && (
            <Button variant="destructive" onClick={onForceOverwrite}>
              Overwrite with My Changes
            </Button>
          )}
          <Button onClick={onSaveAsCopy}>
            Save as New Copy
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
